import { render, staticRenderFns } from "./77.vue?vue&type=template&id=b0234ce8&scoped=true&"
var script = {}
import style0 from "./77.vue?vue&type=style&index=0&id=b0234ce8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0234ce8",
  null
  
)

export default component.exports